var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"badge-new",class:`badge-${_vm.type}`},[_vm._t("default",function(){return [_vm._v("NEW")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }